<template>
    <b-nav-item
      :disabled="(label === 'Содержание' || label === 'Просмотр теста') && isTestCreation"
      :to="url"
      @click="hideIfMobile"
    >
        <em :class="iconClasses"></em>
        <span class="nav-name">{{ label }}</span>
        <b-badge
          v-if="badge && badge.text !== '!'"
          :variant="badge.variant"
          :class="badgeClasses"
        >
          {{ badge.text }}
        </b-badge>
        <b-badge
          v-if="badge &&
            badge.text === '!' &&
            (hasRole('classroom-teacher') || hasRole('content-manager'))"
          :variant="badge.variant"
          class="testErrorBadge"
          v-b-tooltip.hover title="Неверные настройки теста"
        >
          {{ badge.text }}
        </b-badge>
        <b-badge
          v-if="label === 'Сообщения' && unreadChats > 0"
          class="unreadBadge"
          variant="primary">
          {{ this.unreadChats }}
        </b-badge>
        <b-badge
          v-if="label === 'Ожидают рассмотрения' && waitingContent > 0"
          class="unreadBadge"
          variant="primary">
          {{ this.waitingContent }}
        </b-badge>
    </b-nav-item>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'
import { sidebarCssClasses } from '@/components/helpers/classes'
import toggleClasses from '@/components/helpers/toggle-classes'

export default {
  name: 'SidebarNavItem',
  props: {
    label: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default() {
        return null
      }
    }
  },
  methods: {
    ...mapMutations({
      setTestReviewMode: 'educationStudentsManagement/setTestReviewMode'
    }),
    hideIfMobile() {
      this.setTestReviewMode(false)
      const cssClass = sidebarCssClasses[0]
      const width = document.documentElement.clientWidth
      if (width < 992) {
        toggleClasses(cssClass, sidebarCssClasses)
      }
    }
  },
  computed: {
    iconClasses() {
      return [
        'nav-icon',
        'coursebook-icon',
        this.icon
      ]
    },
    badgeClasses() {
      return [
        'badge',
        'nav-badge'
      ]
    },
    ...mapGetters({
      unreadChats: 'chats/getUnreadChats',
      waitingContent: 'content/getCountOfWaitingContent',
      isTestCreation: 'test/isTestCreationMode',
      hasRole: 'currentUser/hasRole'
    })
  }
}
</script>

<style scoped>

  .unreadBadge {
    margin-left: 10px;
  }

  .testErrorBadge {
    margin-left: 10px;
  }

  .coursebook-icon {
    flex-basis: content;
  }
</style>
